module.exports = __webpack_public_path__ + "static/media/menuWeddingReception2.6aae9a3a.jpg";